module.exports = __webpack_public_path__ + "static/media/pro-manPhoto03.e8688b92.jpg";